import { api } from "@/api"
import type { User } from "./types"
import { useQuery } from "@tanstack/vue-query"
import type { MaybeRef } from "@vueuse/core"
type ListUsersQuery = {
  search?: string
  ordering?:
    | "email"
    | "-email"
    | "name"
    | "-name"
    | "lastLogin"
    | "-lastLogin"
    | "createdAt"
    | "-createdAt"
} & Pagination

export type ListUsersFilter = Pick<ListUsersQuery, "search">

export type ListUsersOrdering = ListUsersQuery["ordering"]

export type ListUsersResponseItem = User & {
  lastLogin: Date | null
  createdAt: Date
}

const listUsers = async (query?: ListUsersQuery) => {
  const { body } = await api.get<
    RecursivelyConvertDatesToStrings<
      Paginate<ListUsersResponseItem[]>
    >
  >("/users/", { query: query })

  return {
    ...body,
    items: body.items.map((user) => ({
      ...user,
      createdAt: DateFns.parseISO(user.createdAt),
      lastLogin: user.lastLogin
        ? DateFns.parseISO(user.lastLogin)
        : null,
    })),
  }
}

export const useUsers = (
  query?: MaybeRef<ListUsersQuery>
) =>
  useQuery({
    queryKey: [BASE_USERS_QUERY_KEY, query] as const,
    queryFn: ({ queryKey: [_, query_] }) =>
      listUsers(query_),
  })
